/**
 * Concept for an exercise.
 */
export abstract class Subject<E extends Exercise, R extends Result> {

	/** The ID of the subject, like "simple-intervals". */
	abstract id: string
	/** The localized name of the subject. */
	abstract name: string
	/** The localized description of the subject. */
	abstract description: string
	/** The ID of the exercise page. */
	abstract page: string

	/** Creates a random exercise for this subject. */
	abstract createExercise(): E

	/** Grades the given results. */
	abstract grade(results: R[]): Grade
}

/** Interface for all types of exercises. */
export interface Exercise {
}

/** Interface for all types of results for the statistics. */
export interface Result {
}

/** A grading between 0 (worst grade) and 1 (perfect). */
export type Grade = number


// WEBPACK FOOTER //
// ./src/model/subject.ts